<template>
  <div>
    <form @submit.prevent="updateManufacturer(true)">
      <div class="flex flex_gap">
        <div class="">
          <label>Название производителя</label>
          <input required type="text" v-model="newManufacturer.title" class="form-control">
        </div>
        <div class="flex-grow-1">
          <label>Короткое описание</label>
          <input type="text" v-model="newManufacturer.text" class="form-control">
        </div>
      </div>
      <div class="mt-1 flex">
        <div class="flex-grow-1 pr-2">
          <label>Контакты</label>
          <button @click="addPhone()" type="button" class="btn btn-outline-info btn-xs">добавить контакт</button>
          <div v-for="(p,i) in newManufacturer.data.phones" :key="i" class="input-group">
            <input type="text" placeholder="номер или email" v-model="p.phone" class="form-control">
            <input type="text" placeholder="комментарий" v-model="p.comment" class="form-control">
            <button @click="addPhone(i)" type="button" class="btn btn-outline-danger"><i
              class="icon-fa icon-fa-remove"/>
            </button>
          </div>
        </div>
        <div class="flex-grow-1">
          <label>Комментарий</label>
          <textarea class="form-control" v-model="newManufacturer.data.comment"
                    placeholder="Комментарии к производителю..." rows="3"/>
        </div>
      </div>
      <div class="text-right mt-1">
        <!--        <div class="flex flex_gap_10">-->
        <!--          <LoadingButton-->
        <!--            v-if="addManufactureToRecord"-->
        <!--            title="Привязать производителя к задаче"-->
        <!--            className="btn btn-outline-info"-->
        <!--            type="button"-->
        <!--            :onClick="() => addManufactureToRecord(true)"-->
        <!--            :loading="saveLoading"-->
        <!--            :color="$constants.LOADING_COLOR"-->
        <!--          />-->
        <LoadingButton
          :title="(newManufacturer?.id ? 'Обновить производителя' : 'Сохранить производителя') + (this.onSelectManufacturer ? ' и привязать к задаче' : '')"
          className="btn btn-outline-success"
          type="button"
          :onClick="() => updateManufacturer(true)"
          :loading="saveLoading"
          :color="$constants.SUCCESS_COLOR"
        />
        <!--        </div>-->
      </div>
    </form>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  props: ['savedManufacturer', 'onSelectManufacturer'],
  components: {LoadingButton},
  data() {
    return {
      saveLoading: false,
      disableEdit: false,
      newManufacturer: {
        data: {
          phones: [{phone: '', comment: ''}],
          comment: '',
        }
      },
    }
  },
  created() {
    if (this.savedManufacturer?.id) {
      this.disableEdit = true;
      this.newManufacturer = {...this.savedManufacturer};
    }
  },
  methods: {
    addPhone(index = null) {
      if (index !== null) {
        delete this.newManufacturer.data.phones[index];
        this.newManufacturer.data.phones = this.newManufacturer.data.phones.filter((p) => p);
        return;
      }
      this.newManufacturer.data.phones.push({
        phone: '',
        comment: ''
      })
    },
    async updateManufacturer() {
      this.saveLoading = true;
      const {data} = await api.post('/new/nomenclature/manufacturer', {
        manufacturer: this.newManufacturer
      })
      if (data.success) {
        toastr['success']('сохранено', 'Успешно');
        this.newManufacturer = data.record;
        if (this.onSelectManufacturer) {
          this.onSelectManufacturer({...this.newManufacturer});
        }
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера');
      }
      this.saveLoading = false;
    }
  }
}
</script>

<style scoped>
.flex_gap {
  gap: 5px;
}
</style>
